import type { RouteRecord } from 'vite-react-ssg';
import App from './App';
import Portfolio from './Portfolio/Portfolio';
import AcademicWork from './Portfolio/AcademicWork';
import Storenvy from './Portfolio/Storenvy';
import LittleRedHen from './Portfolio/LittleRedHen';
import Engelbrecht from './Portfolio/Engelbrecht';
import About from './About';

export const routes: RouteRecord[] = [
    {
        path: '/',
        element: <App />,
        children: [
            // `/` renders the Portfolio shell; Portfolio falls back to
            // AcademicWork when its <Outlet/> has no nested route.
            { index: true, element: <Portfolio /> },
            {
                path: 'portfolio',
                element: <Portfolio />,
                children: [
                    { index: true, element: <AcademicWork /> },
                    { path: 'storenvy', element: <Storenvy /> },
                    { path: 'little-red-hen', element: <LittleRedHen /> },
                    { path: 'engelbrecht-advertising', element: <Engelbrecht /> },
                ],
            },
            { path: 'about', element: <About /> },
        ],
    },
];
